import { render, staticRenderFns } from "./courseDelete.vue?vue&type=template&id=4cec51af&"
import script from "./courseDelete.vue?vue&type=script&lang=js&"
export * from "./courseDelete.vue?vue&type=script&lang=js&"
import style0 from "./courseDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports